module.exports = __webpack_public_path__ + "img/logo_moons.ae846e66.svg";